import { browserTracingIntegration, dedupeIntegration, init } from '@sentry/angular-ivy';

interface Environment {
    appVersion: string;
    production: boolean;
}

export class Sentry {
    // Capture 10% of the transactions
    private readonly TRACE_SAMPLE_RATE: number = 0.01;

    // This sets the sample rate at 10%.
    private readonly REPLAYS_SESSION_SAMPLE_RATE: number = 0.01;

    // If you're not already sampling the entire session.
    private readonly REPLAYS_ON_ERRORS_SAMPLE_RATE: number = 1.0;

    constructor(environment: Environment) {
        this.init(environment);
    }

    private init(environment: Environment): void {
        init({
            dsn: 'https://348afcd10b9e94884def597256c04132@o1250271.ingest.sentry.io/4506100335181824',
            integrations: [
                dedupeIntegration(), // Deduplicate certain events to avoid receiving duplicate errors.
                browserTracingIntegration({
                    traceFetch: true,
                    traceXHR: true
                })
            ],

            release: environment.appVersion,
            tracePropagationTargets: [/^https:\/\/.*\.mediahaven\.com/],
            environment: window.location.hostname,
            // Performance Monitoring
            tracesSampleRate: this.TRACE_SAMPLE_RATE,
            // Session Replay
            replaysSessionSampleRate: this.REPLAYS_SESSION_SAMPLE_RATE,
            replaysOnErrorSampleRate: this.REPLAYS_ON_ERRORS_SAMPLE_RATE
        });
    }
}
